import React, { useState, useEffect } from 'react';
import { GetProcessInfo, SendProcessMessage, CheckHashInCollections, BorrowAvatar, WAR } from '../MiscTools';
import { PermissionType } from 'arconnect';
import { useGlobalContext } from '././GlobalProvider';

const permissions: PermissionType[] = [
    'ACCESS_ADDRESS',
    'SIGNATURE',
    'SIGN_TRANSACTION',
    'DISPATCH'
];

interface AvatarMenuProps {
    showAvatarMenu: boolean;
    setShowAvatarMenu: React.Dispatch<React.SetStateAction<boolean>>;
}

interface Asset {
    Quantity: string;
    Id: string;
    Type?: string; // Optional, since not all assets may have a Type
}

const AvatarMenu: React.FC<AvatarMenuProps> = ({ showAvatarMenu, setShowAvatarMenu }) => {

    const {
        walletAddress,
        setWalletAddress,
        avatarHash,
        setAvatarHash,
        decks,
        setDecks,
        activeDeck,
        setActiveDeck,
      } = useGlobalContext();
    
    // const [address, setAddress] = useState<string>("eqWPXgEngDqBptVFmSlJT0YC9wgyAD4U8l1wrqKu_WE");
    const [inputValue, setInputValue] = useState<string>("");
    const [assets, setAssets] = useState<Asset[]>([]);
    const [profileMatch, setProfileMatch] = useState<boolean>(false);
    const [selectedAsset, setSelectedAsset] = useState<string>("");
    const [collectionData, setCollectionData] = useState<string>("");
    const [collectionAssets, setCollectionAssets] = useState<Asset[]>([]);
    const [matchingAssets, setMatchingAssets] = useState<Asset[]>([]);

    useEffect(() => {
        if (assets && assets.length > 0) {
          console.log("Assets:", assets);

          const lkSkelBack = assets.some(asset => asset.Id === "zD1CdD4CK0Ea6j8MQopw08fnNEtJsO1a1r_MsV_nKyg");
          const lkZombieBack = assets.some(asset => asset.Id === "repuYDasn9R_A7S-CHONCatzp6FYkQFCwOk4lEtsWUs");
          const lkGhostBack = assets.some(asset => asset.Id === "MVYAhGFvw3M4cPnULd29OrXZsKIzdgB6FE4rR6gVB9I");

          if (lkSkelBack) { console.log(`Have lkSkelBack`);
            if (!decks.includes("IQm3nx-Dk2paYxhCQS3lH8LQ5v--L40rjSfyBUeryCo")) {
                setDecks((decks) => [...decks, "IQm3nx-Dk2paYxhCQS3lH8LQ5v--L40rjSfyBUeryCo"]);
               }
           } else { console.log(`Dont have lkSkelBack.`); }
          if (lkZombieBack) { console.log(`Have lkZombieBack`);
            if (!decks.includes("4EhNhinH6-LJXsNug3woJqIK9AhmSzVWJ75t_mxS_Do")) {
                setDecks((decks) => [...decks, "4EhNhinH6-LJXsNug3woJqIK9AhmSzVWJ75t_mxS_Do"]);
               }
           } else { console.log(`Dont have lkZombieBack.`); }
          if (lkGhostBack) { console.log(`Have lkGhostBack`);
            if (!decks.includes("c8vtR7OmemFLPe_X1jRAahHwjlFcW70U_HSq8PrlEMk")) {
                setDecks((decks) => [...decks, "c8vtR7OmemFLPe_X1jRAahHwjlFcW70U_HSq8PrlEMk"]);
               }
           } else { console.log(`Dont have lkGhostBack.`); }
          
        }
      }, [assets]);

    
    if (!showAvatarMenu) {
        return null; // Don't render the menu if it's not supposed to be visible
    }

    // useEffect(() => {
    // }, [ showAvatarMenu ]);

    // BazAR ID Input
    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setInputValue(e.target.value);
        // Additional logic can be added here if you want to trigger something immediately after input changes
    };

    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === 'Enter') {
            // Trigger the function when "Enter" is pressed
            handleSubmit();
        }
    };

    // Drop down menu
    const handleAssetsSelectChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        // setSelectedAsset(e.target.value);
        setAvatarHash(e.target.value);
        console.log("Selected asset ID:", e.target.value);

        // Check if the selected asset is a DumDumz
        CheckValidAtomicAsset(e.target.value);
    };

    // Borrow Avatar
    const setBorrowAvatar = async () => {
        try {
            const id = await BorrowAvatar();
            setAvatarHash( id );
            if (!decks.includes("j845jS0fUDkn7cTkV-vJytAQw_R1NsaSz364BOQoruQ")) {
                setDecks((decks) => [...decks, "j845jS0fUDkn7cTkV-vJytAQw_R1NsaSz364BOQoruQ"]);
               }
            console.log("Selected asset ID:", id);
        } catch (error) {
            console.error("There was an error during the submission process:", error);
        }
    };

    const CheckValidAtomicAsset = async ( hash: string ) => {
        console.log("Checking if asset is a DumDumz:", hash);
        
        try {
            const found = await CheckHashInCollections(hash);

            if(found) {
                console.log("Avatar is a DumDumz:", found);

                if (!decks.includes("j845jS0fUDkn7cTkV-vJytAQw_R1NsaSz364BOQoruQ")) {
                 setDecks((decks) => [...decks, "j845jS0fUDkn7cTkV-vJytAQw_R1NsaSz364BOQoruQ"]);
                }
            } else {
                console.log("Avatar is not a DumDumz:", found);
            }

        } catch (error) {
            console.error("Failed to fetch:", error);
        }
    };

    // Reset BazAR data
    const resetWalletAssets = () => {
        setAssets([]);
        setSelectedAsset('');
        setMatchingAssets([]);
    };

    const handleSubmit = async () => {
        if (!inputValue || inputValue.trim() === "") {
            console.log("Input value is empty or null.");
            return;
        }

        resetWalletAssets();
    
        try {
            // Call TestSend and wait for the result
            const result = await GetProcessInfo(inputValue);
    
            // Additional logic based on the result
            if (result.startsWith("Error")) {
                console.log("An error occurred:", result);
            } else {
                // console.log("Success, data received:", result);

                const parsedResult = JSON.parse(result);
                
                // Make sure the owner is the same as the connected address
                if (parsedResult.Owner !== walletAddress) {
                    setProfileMatch(false);
                    console.log("The owner of the profile is different from the connected address.");
                    return;
                } else {
                    setProfileMatch(true);
                    console.log("The owner of the profile is the same as the connected address.");
                }

                if (result && parsedResult.Assets) {
                    setAssets(parsedResult.Assets);
        
                    // Check for matching assets after setting both assets and collection data
                    // const matchingAssets = findMatchingAssets(assets, parsedResult.Assets);
                    // setMatchingAssets(matches);
                    // console.log("Matching assets:", matchingAssets);
                }

                
            }
        } catch (error) {
            console.error("There was an error during the submission process:", error);
        }
    
        console.log("Input value submitted:", inputValue);
    };

    const deleteCurrentGame = async () => {
        console.log("Deleting current game...");
        try {
            SendProcessMessage( WAR, "DeleteGame", "{}");
        } catch (error) {
            console.error("There was an error during the submission process:", error);
        }
    };

    const setDeck = (url: string) => {
        setActiveDeck(url);
      };

  return (
    <div
      className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50" // Full-screen overlay
    >
      <div
        className="w-[80%] h-[80%] bg-black bg-opacity-80 p-6 rounded-3xl shadow-lg" // Menu container
      >

        <button
          onClick={() => setShowAvatarMenu(false)}
          className="absolute top-4 left-4 text-white font-bold bg-slate-800 rounded-full w-8 h-8 flex items-center justify-center hover:bg-red-600"
        >
          X
        </button>

        <h3 className="text-2xl font-semibold text-center">Select Your Avatar</h3>
        <p className="text-lg text-gray-600 text-center">Use a DumDumz NFT to unlock a special Deck</p>

        
        <input
            type="text"
            placeholder="Enter your BazAR profile ID"
            value={inputValue}
            onChange={handleInputChange}
            onKeyDown={handleKeyDown}
            className="mt-4 px-4 py-2 w-full bg-gray-100 text-gray-900 rounded-lg shadow-md focus:outline-none focus:ring-2 focus:ring-red-400 focus:ring-opacity-75"
        />

        <button onClick={handleSubmit} className="mt-4 bg-amber-500 text-white font-bold px-4 rounded hover:bg-amber-600 m-2" >
            Submit Profile
        </button>
            

        {profileMatch ? (
            <p className="text-green-600 font-bold">
                Profile matched successfully!
            </p>
        ) : (
            <p className="text-red-600 font-bold">
                Not profile owner
            </p>
        )}

        <div>
            {assets.length > 0 && (
                <div>
                    <select
                        value={selectedAsset}
                        onChange={handleAssetsSelectChange}
                        className="mt-4 px-4 py-2 w-full bg-gray-100 text-gray-900 rounded-lg shadow-md focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-opacity-75"
                    >
                        <option value="">Select an asset</option>
                        {assets.map((asset, index) => (
                            <option key={index} value={asset.Id}>
                                {asset.Id} (Quantity: {asset.Quantity}){" "}
                                {asset.Type && `(Type: ${asset.Type})`}
                            </option>
                        ))} 
                    </select>
                </div>
            )}
        </div>

        

        {/* <button className="bg-blue-500 text-white font-bold px-4 rounded hover:bg-blue-600 m-2" 
        onClick={ setBorrowAvatar }>
            Borrow DumDumz
        </button> */}

        <h3 className="text-2xl font-semibold mb-4 text-center p-4">Select Your Deck</h3>
        <ul className="flex justify-center space-x-4 overflow-x-auto list-none">
            {decks.map((url, index) => (
                <li key={index}>
                <button
                    className="flex-none w-24 h-32 border rounded-lg focus:outline-none hover:shadow-lg"
                    onClick={() => setDeck(url)}
                >
                    <img
                    src={`https://arweave.net/${url}`}
                    alt={`Button ${index + 1}`}
                    className="w-full h-full object-cover rounded-lg"
                    />
                </button>
                </li>
            ))}
        </ul>

        <button className="mt-4 bg-red-500 text-white font-bold px-4 rounded hover:bg-red-600 m-2" 
        onClick={deleteCurrentGame}>
            Delete Current Game
        </button>

      </div>
    </div>
  );
};

export default AvatarMenu;
